import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: '[app-contact-info]',
  templateUrl: './contact-info.component.pug',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {

  @Input() contacts;
  @Input() finishedGettingContacts:boolean = false;
  contactsScrollHeight;
  constructor() { }

  ngOnInit() {
  }
  ngOnChanges(changes:SimpleChanges){
    if(changes.contacts?.currentValue?.length){
      if(changes.contacts?.currentValue?.length > 10){
        this.contactsScrollHeight = '200px'
      } else {
        this.contactsScrollHeight = null;
      }
    }
  }

  getMobileContact(contact) {
    if (contact.phone?.phone_type === 'MOBILE') {
      return contact.phone;
    } else if (contact.sms_phone?.phone_type === 'MOBILE') {
      return contact.sms_phone;
    }
    return null;
  }

}
